import {getField, updateField} from 'vuex-map-fields';
import * as API from '@/api';

function initialState () {
  return {
    list: [],
  };
}

const state = initialState ();

// actions

const actions = {
  async getPricing (context, payload) {
    var response = await API.monetization.getPricing (payload);
    return response.pricing;
  },

  async listPricing (context, payload) {
    var response = await API.monetization.listPricing (payload);
    context.commit ('set_list', response);
    return response;
  },

  async markPaid (context, payload) {
    var response = await API.monetization.markPaid (payload);
    return response;
  }
};

// getters
const getters = {
  getPricing: state => pricing_id => {
    var pricing = null;
    if (state.list) {
      pricing = state.list.find (pricing => {
        return pricing.id == pricing_id;
      });
    }
    return pricing;
  },
};

// mutations
const mutations = {
  updateField,
  set_list (state, payload) {
    state.list = payload.pricing;
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
